import { render, staticRenderFns } from "./SafeVerifyModal.vue?vue&type=template&id=f346d1f8&scoped=true"
import script from "./SafeVerifyModal.vue?vue&type=script&lang=js"
export * from "./SafeVerifyModal.vue?vue&type=script&lang=js"
import style0 from "./SafeVerifyModal.vue?vue&type=style&index=0&id=f346d1f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f346d1f8",
  null
  
)

export default component.exports